import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const service = axiosWithHeaders({
	config,
	service: 'amInspection',
	axiosCreateOpts: {
		timeout: 15000,
	},
});

export default service;
